import { MessageOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { IRestrictedUser } from 'interfaces';
import React, { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { createGLobalChat } from 'store/reducers/chatCreator';
import classes from './ContactsTab.module.scss';

type ContactsCardProps = {
  user: IRestrictedUser;
  onItemClick: (user: IRestrictedUser) => void;
  searchValue?: string;
  markText?: (text: string, markerRef: React.RefObject<HTMLDivElement>, timeout?: number) => void;
};

const ContactsCard = ({ user, onItemClick, searchValue, markText }: ContactsCardProps) => {
  const markerTitle = React.useRef<HTMLDivElement>(null);
  const markerDesc = React.useRef<HTMLDivElement>(null);
  
  const [installingNewRole, setInstallingNewRole] = React.useState(false);

  const { userData } = useAppSelector((state) => state.userData);
  const { dataRoom } = useAppSelector((store) => store.dataRoom);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (markText) {
      const text = searchValue || '';
      markText(text, markerTitle);
      markText(text, markerDesc);
    }
  }, [searchValue]);

  const onChatClick = async (event: React.MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    const { payload } = (await dispatch(
      createGLobalChat({
        data: {
          members_ids: [userData?.id!, user.id],
          entity_type: 3,
          room_id: dataRoom?.id!,
          title: user.email,
        },
        ownerId: userData?.id!,
        oponentName: `${user.first_name} ${user.last_name}`,
      })
    )) as any;
    navigate(`/global-chats/${payload.chat.id}/`);
  };

  const { t } = useTranslation();

  const fullName = `${user.first_name} ${user.last_name}`;

  const onContanctClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    onItemClick(user)
  }

  return (
    <div
      className={classNames(classes.userCard, installingNewRole ? classes.loading : null)}
      onClick={onContanctClick}
    >
      <div className={classes.jusctifySpace}>
        <div ref={markerTitle} className={classes.userTitle}>
          <Tooltip title={fullName} mouseEnterDelay={1}>
            {fullName}
          </Tooltip>
        </div>

        <div>
          {userData?.email !== user.email && (
            <Tooltip title={t('Users.HelperMenu.userChat')} zIndex={1000}>
              <MessageOutlined onClick={onChatClick} />
            </Tooltip>
          )}
        </div>
      </div>
      <div className={classes.jusctifySpace}>
        <div ref={markerDesc} className={classes.userDescription}>
          <Tooltip title={user.email} mouseEnterDelay={1}>
            {user.email}
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default ContactsCard;
